import Token from 'vindi-ds-tokens';

const buttonMargin = {
  margin: '0px',
  marginBottom: Token.spacing.medium.value,
};

export default {
  errorsAlert: {
    marginBottom: '1em',
  },
  formBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '2em',
    backgroundColor: Token.color.functional.light['100'].value,
  },
  formHeading: {
    marginBottom: Token.padding.inset.small.value,
  },
  vindiLogo: {
    width: '121px',
    height: '28.24px',
    marginBottom: Token.spacing.medium.value,
  },
  buttonMobile: {
    ...buttonMargin,
  },
  button: {
    ...buttonMargin,
    width: '50%',
  },
  signInLink: {
    padding: '0px',
    fontSize: Token.font.size.xxs.value,
  },
  recaptcha: {
    marginBottom: Token.spacing.small.value,
  },
  termHr: {
    width: '100%',
    borderTop: '2px solid #eeeeee',
  },
};
